<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card color="#FFD375" class="elevation-12">
        <v-toolbar color="#FFA500">
            <v-toolbar-title>{{title}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field class="mt-6" name="name" label="Name" v-model="name" :rules="nameRules" required></v-text-field>
                <v-text-field class="mt-6" name="email" label="Email" v-model="email"></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#FFA500" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
     value: Boolean,
     selectedcontact: Object
  },
  data() {
      return {
          valid: false,
          contact: this.selectedcontact,
          //contact: null,
          name: "",
          email: "",
          modal: false,
          nameRules: [
              v => !!v || 'Name is required',
          ]
      };
  },
  computed: {
    show: {
      get () {
            this.contact = this.selectedcontact;
            this.initialiseData();
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    },
    title(){
        if (!this.contact)
            return "New Contact";
        else 
            return "Edit Contact";
    }
    
  },
  methods: {
      initialiseData(){
          if (!this.selectedcontact)
              {
              this.name="";
              this.email="";
              }
          else {
              this.name=this.selectedcontact.Name;
              this.email=this.selectedcontact.Email;
          }
      },
      cancel(){
          this.name='';
          this.email='';
          this.show=false;
      },
      submit() {
        var xn=this.name;
        var g=0;
          if (this.$refs.form.validate()) {
              if (!this.selectedcontact)
                  this.contact={};
              this.contact.Name=this.name;
              this.contact.Email=this.email;
              if (!this.selectedcontact){
                  //this.$store.dispatch('addContact', this.contact);
                  this.$store.dispatch('checkExisitingContact', this.contact);
              }
              else {
                  this.$store.dispatch('setContact', this.contact);
              }
              this.name='';
              this.email='';
              this.show=false;
          }
      }
  }
}
</script>